// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialLink-module--container--3MeDR","blob":"SocialLink-module--blob--2AyU3","icon":"SocialLink-module--icon--35Z2j","isGithub":"SocialLink-module--is-github--2wfn5"};